<template>
  <div
    v-if="configData.show && showGoTop"
    class="goTop"
    @click="scrollToTop"
  >
    <template-button
      :btn-config="configData"
      :default-height="'50px'"
      :default-width="'50px'"
    />
  </div>
</template>

<script>
import TemplateButton from './TemplateButton.vue'

export default {
  components: {
    TemplateButton,
  },
  props: {
    configData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showGoTop: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showGoTop = window.scrollY > 10
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.goTop {
  position: fixed;
  z-index: 1000;
  bottom: 5%;
  right: 5%;
  cursor: pointer;
}
</style>
